const ProcessRequestQueryKeys = {
	all: ['process-request'] as const,
	latestActiveExecutionState: () => [...ProcessRequestQueryKeys.all, 'latest-active-execution-state'] as const,
	executionState: (requestId: number) => [...ProcessRequestQueryKeys.all, 'execution-state', requestId] as const,
};

export default ProcessRequestQueryKeys;
